import styled from 'styled-components';
import { Grid, buttonCSS } from '@simplywallst/ui-core';
import type { ButtonProps } from '@simplywallst/ui-core';
import { RouterLink as DefaultRouterLink } from '@redux-first-router-link';

export const Chart = styled(Grid)<{ active: boolean }>`
  transition: background 0.5s;
  background: ${({ theme, active }) =>
    active ? 'transparent' : theme.color.whiteRGBA(0.05)};
`;

export const Analysis = styled(Grid)`
  height: 100%;
`;

export const RouterLink = styled(DefaultRouterLink)<ButtonProps>`
  ${buttonCSS}
  text-align: center;
`;
